export default __webpack_public_path__ + "static/media/strategyEng4.0f26a9b8.jpg";